const CHANNEL_ALIASES: Record<string, string[]> = {
  RPM: ["RPM", "ENGINE_RPM"],
  SPEED: ["SPEED", "VEHICLE_SPEED", "WHEEL_SPEED", "KPH", "MPH"],
  THROTTLE_POS: ["THROTTLE_POS", "TPS", "THROTTLE", "THROTTLE_POSITION", "ACCEL_PEDAL_POS"],
  BRAKE: ["BRAKE", "BRAKE_POS", "BRAKE_PEDAL", "BRAKE_PEDAL_POS", "BRAKE_PRESSURE"],
  ENGINE_LOAD: ["ENGINE_LOAD", "LOAD", "CALC_LOAD"],
  COOLANT_TEMP: ["COOLANT_TEMP", "ENGINE_COOLANT_TEMP", "ECT"],
  OIL_TEMP: ["OIL_TEMP", "ENGINE_OIL_TEMP"],
  OIL_PRESS: ["OIL_PRESS", "OIL_PRESSURE"],
  INTAKE_TEMP: ["INTAKE_TEMP", "IAT", "INTAKE_AIR_TEMP"],
  AFR: ["AFR", "LAMBDA"],
  FUEL: ["FUEL", "FUEL_LEVEL", "FUEL_PCT", "FUEL_PERCENT"],
  GPS_LAT: ["GPS_LAT", "GPS_LATITUDE", "LAT"],
  GPS_LNG: ["GPS_LNG", "GPS_LONGITUDE", "GPS_LON", "LON", "LNG", "LONG"],
  GPS_SPEED: ["GPS_SPEED", "GROUND_SPEED"],
  GPS_ALT: ["GPS_ALT", "GPS_ALTITUDE", "ALT", "ALTITUDE"],
};

const aliasToCanonical = new Map<string, string>();

function normalizeToken(value: string) {
  return value
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

for (const [canonical, aliases] of Object.entries(CHANNEL_ALIASES)) {
  aliasToCanonical.set(normalizeToken(canonical), canonical);
  for (const alias of aliases) {
    aliasToCanonical.set(normalizeToken(alias), canonical);
  }
}

function extractCandidates(rawChannel: string) {
  const candidates = new Set<string>();
  const normalizedRaw = normalizeToken(rawChannel);
  if (normalizedRaw) {
    candidates.add(normalizedRaw);
  }

  const slashSegment = rawChannel.split("/").at(-1);
  if (slashSegment) {
    const normalizedSlash = normalizeToken(slashSegment);
    if (normalizedSlash) {
      candidates.add(normalizedSlash);
    }
  }

  const dotSegment = rawChannel.split(".").at(-1);
  if (dotSegment) {
    const normalizedDot = normalizeToken(dotSegment);
    if (normalizedDot) {
      candidates.add(normalizedDot);
    }
  }

  return [...candidates];
}

export function canonicalizeChannelName(rawChannel: string) {
  const candidates = extractCandidates(rawChannel);
  for (const candidate of candidates) {
    const canonical = aliasToCanonical.get(candidate);
    if (canonical) {
      return canonical;
    }
  }

  return candidates[0] ?? normalizeToken(rawChannel);
}
